import { computed, ref } from 'vue'

export function paginate(source, options = null) {
    const page = ref(options?.page ?? 1)
    const pageSize = ref(options?.pageSize ?? 20)

    const all = computed(source)

    const results = computed(() => {
        const start = (page.value - 1) * pageSize.value
        const end = start + pageSize.value
        return all.value.slice(start, end)
    })

    const overflow = computed(() => (page.value - 1) * pageSize.value >= all.value.length)

    return {
        get count() {
            return all.value?.length ?? 0
        },
        get overflow() {
            return overflow.value
        },
        get page() {
            return page.value
        },
        set page(value) {
            page.value = value
        },
        get pageSize() {
            return pageSize.value
        },
        set pageSize(value) {
            pageSize.value = value
        },
        get results() {
            return results.value
        },
    }
}
